import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const FolderContainerLoader: LoadableType<{
	contentId: string;
}> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-FolderContainer" */ '../src/FolderContainer.tsx'))
			.FolderContainer,
});
